import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, Lock } from 'lucide-react';
import { Button } from '../ui/Button';
import { Accordion } from '../ui/Accordion';
export function OfferFAQ() {
  const faqs = [{
    question: '¿Tengo que comprar carne carísima?',
    answer: 'No, te enseñamos a elegir cortes inteligentes en cualquier carnicería.'
  }, {
    question: '¿Lleva mucho tiempo preparar estas marinadas?',
    answer: 'Menos de 5 minutos. Es más rápido que ir a comprar una salsa embotellada.'
  }, {
    question: '¿Puedo seguir bebiendo algo con el asado?',
    answer: 'Sí, dentro de la guía te damos las mejores opciones para no disparar la inflamación.'
  }, {
    question: '¿Es un libro de recetas largo?',
    answer: 'No, es un manual operativo diseñado para hombres ocupados que quieren resultados, no teoría.'
  }];
  return <section className="py-20 bg-dark-warm" id="offer" data-id="element-117">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        {/* Proof / Believability */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-dark-lighter to-dark p-8 md:p-10 rounded-2xl border border-amber/20 mb-20 shadow-xl" data-id="element-119">
          <div className="flex items-center gap-3 mb-6" data-id="element-120">
            <Clock className="w-8 h-8 text-amber" data-id="element-121" />
            <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-122">
              Lo que cambia en 7 días
            </h3>
          </div>
          <p className="text-lg md:text-xl text-offwhite/90 leading-relaxed" data-id="element-123">
            Al eliminar los aceites de semillas y los azúcares ocultos de tu
            parrillada del domingo, notarás que la inflamación en tus manos y
            rodillas se reduce drásticamente en{' '}
            <strong className="text-amber" data-id="element-124">menos de 24 horas</strong> después de
            comer. El "bajón" post-asado desaparece.
          </p>
        </motion.div>

        {/* FAQ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-24" data-id="element-125">
          <h2 className="text-4xl font-bold text-center mb-10" data-id="element-126">
            Preguntas Frecuentes
          </h2>
          <Accordion items={faqs} data-id="element-127" />
        </motion.div>

        {/* Offer Block */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-dark border-2 border-amber rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-[0_0_50px_rgba(232,130,12,0.2)]" data-id="element-128">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-fire-gradient" data-id="element-129"></div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-130">
            Recupera tus domingos y protege tus articulaciones
          </h2>
          <p className="text-xl text-offwhite/80 mb-8 max-w-2xl mx-auto" data-id="element-131">
            Por menos de lo que cuesta un kilo de carne de baja calidad. Obtén
            el sistema completo "Parrillada Sin Dolor" hoy mismo.
          </p>

          <div className="mb-10" data-id="element-132">
            <p className="text-offwhite/60 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-133">
              Inversión única
            </p>
            <div className="text-6xl md:text-8xl font-bold text-transparent bg-clip-text bg-fire-gradient drop-shadow-sm" data-id="element-134">
              $6.34
            </div>
          </div>

          <Button className="w-full md:w-auto md:px-12 py-5 text-2xl mb-6" data-id="element-135">
            ¡Quiero mi guía parrillada sin dolor!
          </Button>

          <div className="flex items-center justify-center gap-2 text-offwhite/60 text-sm" data-id="element-136">
            <Lock className="w-4 h-4" data-id="element-137" />
            <span data-id="element-138">Acceso instantáneo después del pago seguro.</span>
          </div>
          <div className="flex items-center justify-center gap-2 mt-4 text-offwhite/40 text-xs" data-id="element-139">
            <Shield className="w-4 h-4" data-id="element-140" />
            <span data-id="element-141">Garantía de satisfacción 100%</span>
          </div>
        </motion.div>
      </div>
    </section>;
}